// extracted by mini-css-extract-plugin
export default {"details":"MenuPage_details__AmB2A","sections":"MenuPage_sections__tKyoe"};